import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ScheduleBookingWizard } from "@/components/booking/ScheduleBookingWizard";
import { pageHead } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

const scheduleSearchSchema = z.object({
  package: z.string().optional(),
});

export const Route = createFileRoute("/schedule")({
  validateSearch: scheduleSearchSchema,
  head: () =>
    pageHead({
      title: m.booking_meta_title(),
      description: m.booking_meta_description(),
      path: "/schedule",
    }),
  component: SchedulePage,
});

function SchedulePage() {
  const { package: packageParam } = Route.useSearch();
  return <ScheduleBookingWizard packageParam={packageParam} />;
}
